/* eslint-disable */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
  mdiViewDashboard,
  mdiAccountAlert,
  mdiBusDoubleDecker,
  mdiAccountArrowLeft,
  mdiAccountArrowLeftOutline,
  mdiFaceAgent,
  mdiTextBoxMultipleOutline,
  mdiCashMultiple,
} from "@mdi/js";
export default [
  'General',
  [
    {
      to: '/comboard-dashboard',
      icon: mdiViewDashboard,
      label: 'sidebar.dashboard'
    }
  ],
  'Example',
  [
    {
      label: "Transaction",
      subLabel: "Submenus Transaction",
      icon: mdiCashMultiple,
      menu: [
        {
          to: "/invoicetransaction-parent",
          label: "sidebarFin.invoicetransaction",
          icon: mdiTextBoxMultipleOutline,
        },
        {
          to: "/paymenttransaction-parent",
          label: "sidebarFin.paymenttransaction",
          icon: mdiTextBoxMultipleOutline,
        },
      ],
    },
    {
      label: "Permission Request",
      subLabel: "Submenus Teacher",
      icon: mdiFaceAgent,
      menu: [
        {
          to: "/permissions-parent",
          label: "Permissions",
          icon: mdiFaceAgent,
        },
      ],
    },
    {
      label: "Attendance",
      subLabel: "Submenus Attendance",
      icon: mdiAccountArrowLeft,
      menu: [
        {
          to: "/attendancelist-parent",
          label: "Regular Subject",
          icon: mdiAccountArrowLeftOutline,
        },
        // {
        //   to: "/attendancestreaming-parent",
        //   label: "Streaming Subject",
        //   icon: mdiAccountArrowLeftOutline,
        // },
        {
          to: "/reportattendancedaily-parent",
          label: "Daily Attendance Report",
          icon: mdiAccountAlert,
        },
        {
          to: '/assignment-special',
          label: 'Special Assignment',
          icon: mdiBusDoubleDecker
        },
      ],
    },
  ],
];
